"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
/**
 * Those are events that are not triggered by the map, but involve th map
 *
 * TODO: Other parts of the app should not be "map-aware", there should be more
 * generic events to which the map can register
 */
const maplibregl = __importStar(require("maplibre-gl"));
const ServiceLocator_1 = __importDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
const events = function (eventManager) {
    return {
        'path.hoverNode': function (node, nodeTitle = node.toString(false)) {
            const popup = new maplibregl.Popup({
                offset: 10,
                anchor: 'bottom'
            });
            const nodeId = node.get('id');
            popup.setLngLat(node.attributes.geography.coordinates);
            if (ServiceLocator_1.default &&
                ServiceLocator_1.default.keyboardManager &&
                ServiceLocator_1.default.keyboardManager.keyIsPressed('alt')) {
                popup.setHTML(`<p>${nodeTitle}<br />${nodeId}${node.attributes.data.weight ? `<br />w${Math.round(node.attributes.data.weight)}` : ''}</p>`);
            }
            else {
                popup.setHTML(`<p>${nodeTitle}</p>`);
            }
            eventManager.emit('map.addPopup', nodeId, popup);
        },
        'path.unhoverNode': function (nodeId) {
            if (ServiceLocator_1.default &&
                ServiceLocator_1.default.keyboardManager &&
                ServiceLocator_1.default.keyboardManager.keyIsPressed('alt')) {
                // keep popup for now when alt is pressed
            }
            else {
                eventManager.emit('map.removePopup', nodeId);
            }
        }
    };
};
exports.default = {
    addEvents: function (eventManager) {
        const _events = events(eventManager);
        for (const eventName in _events) {
            eventManager.on(eventName, _events[eventName]);
        }
    },
    removeEvents: function (eventManager) {
        const _events = events(eventManager);
        for (const eventName in _events) {
            eventManager.off(eventName, _events[eventName]);
        }
    }
};
//# sourceMappingURL=MapRelatedCustomEvents.js.map